import React from "react"
import useT from "../hooks/useT"
import LegalPage from "./LegalPage"
import en from "../legal/en/terms-of-use.md?raw"
import bg from "../legal/bg/obshti-usloviya.md?raw"

const TEXTS = { en, bg }

export default function TermsPage() {
  const t = useT()
  return <LegalPage title={t`Terms of Use`} texts={TEXTS} />
}
